import { DriversRankingVariants } from '@sky-it-livedata/livedata-sports-design-system';
import { RaceSessionType } from '../../../types/lgp';

export const getRankingVariant = (sessionName: RaceSessionType): DriversRankingVariants => {
  switch (sessionName) {
    case 'FP1':
    case 'FP2':
    case 'FP3':
    case 'FP4':
      return 'free-practice-results';
    case 'Q':
    case 'Q1':
    case 'Q2':
    case 'Q3':
    case 'QS':
    case 'SS':
    case 'SS1':
    case 'SS2':
    case 'SS3':
      return 'qualifying-results';
    default:
      return 'race-results';
  }
};